

//export const host = 'http://11813a47.ngrok.io/';
//export const host = 'http://acd7a8c2.ngrok.io/';
//export const host = 'http://api.magnumleap.com/';
//export const host = 'http://127.0.0.1:8000/';
export const host = 'http://api-beta.magnumleap.com/';

export const latest = host + 'api/v1/';
export const login  = host + 'api-auth/login';
export const avatar = host + 'img/user/';



// WEBPACK FOOTER //
// ./src/Frontend/config/api.js